import { render, staticRenderFns } from "./SignFileModal.vue?vue&type=template&id=48edce90&"
import script from "./SignFileModal.vue?vue&type=script&lang=js&"
export * from "./SignFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports